import Hero from "@/components/sections/Hero";
import PrintzeeAdvantage from "@/components/sections/PrintzeeAdvantage";
import About from "@/components/sections/About";
import Services from "@/components/sections/Services";
import Portfolio from "@/components/sections/Portfolio";
import WhyChoose from "@/components/sections/WhyChoose";
import Process from "@/components/sections/Process";
import VisionMission from "@/components/sections/VisionMission";
import Testimonials from "@/components/sections/Testimonials";
import FAQ from "@/components/sections/FAQ";
import Contact from "@/components/sections/Contact";
import CTASection from "@/components/sections/CTASection";
import SiteFooter from "@/components/SiteFooter";

export default function Home() {
  return (
    <main data-testid="printzee-home" className="bg-white dark:bg-[#0B1120] text-[#0F172A] dark:text-white font-body transition-colors">
      <Hero />
      <PrintzeeAdvantage />
      <About />
      <Services />
      <Portfolio />
      <WhyChoose />
      <Process />
      <VisionMission />
      <Testimonials />
      <FAQ />
      <Contact />
      <CTASection />
      <SiteFooter />
    </main>
  );
}
